var _mask, _path, _mask2, _path2, _mask3, _path3, _rect, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 296,
    height: 78,
    viewBox: "0 0 296 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_997_68",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 0.999999C28 0.447715 28.4477 0 29 0H81C81.5523 0 82 0.447715 82 1V6.54855H28V0.999999Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 1C28 -5.07513 32.9249 -10 39 -10H71C77.0751 -10 82 -5.07513 82 1V6.54855C82 6.54855 81.5523 6.54855 81 6.54855H29C28.4477 6.54855 28 6.54855 28 6.54855V1ZM82 6.54855H28H82ZM28 6.54855V0V6.54855ZM82 0V6.54855V0Z",
    fill: "#BF3A96",
    mask: "url(#path-1-inside-1_997_68)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-2_997_68",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82 6L82.2566 48.5892L64.7569 48.6947L64.5003 6.10545L82 6Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2566 48.5892L82.3169 58.589L90.3167 58.5408L90.2565 48.541L82.2566 48.5892ZM74.0001 6.0482L74.2568 48.6374L90.2565 48.541L89.9999 5.9518L74.0001 6.0482ZM82.1964 38.5894L64.6967 38.6949L64.8172 58.6945L82.3169 58.589L82.1964 38.5894Z",
    fill: "#BF3A96",
    mask: "url(#path-3-inside-2_997_68)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "path-5-inside-3_997_68",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 27H47.64V48.7H24V27Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 48.7H14V58.7H24V48.7ZM47.64 38.7H24V58.7H47.64V38.7ZM34 48.7V27H14V48.7H34Z",
    fill: "#6C2575",
    mask: "url(#path-5-inside-3_997_68)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 18,
    width: 52,
    height: 39,
    stroke: "#5FCAE8",
    strokeWidth: 8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2063 48.5977L76.1977 57.8393L64.7528 48.6631L74.2063 48.5977Z",
    fill: "#BF3A96"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.77526 60.302L24.1594 60.0819L7.22819 74.4606L9.77526 60.302Z",
    fill: "#5FCAE8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M129.046 11.12V50H120.46V37.04H107.5V50H98.86V30.56V11.12H113.98H129.046ZM107.5 17.6V24.08V30.56H120.46V17.6H113.98H107.5ZM145.908 11.12H163.188V17.6H158.868V43.52H163.188V50H145.908V43.52H150.228V17.6H145.908V11.12ZM188.534 11.12V28.4C189.614 30.56 191.774 34.718 195.014 40.874C196.04 38.822 198.2 34.664 201.494 28.4V11.12H210.08V31.154C208.244 34.286 204.68 40.604 199.334 50H190.694C188.858 46.868 185.294 40.604 179.894 31.154V21.434V11.12H184.214H188.534ZM226.788 11.12H244.068V17.6H239.748V43.52H244.068V50H226.788V43.52H231.108V17.6H226.788V11.12ZM260.936 11.12H291.122V50H260.936V11.12ZM269.576 43.52H282.536V17.6H269.576V43.52Z",
    fill: "#6C2575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.60fb32a203a58283ff4b045f7b58135a.svg";
export { ForwardRef as ReactComponent };